<div class="row">
  <div class="col-12">
    <div class="card">
      <div class="card-body">
        <div id="status" *ngIf="!loaded && !error">
          <div class="spinner">
            <div></div>
            <div></div>
            <div></div>
          </div>
        </div>

        <ngb-alert [dismissible]="false" type="danger" *ngIf="error">
          {{ error }}
        </ngb-alert>

        <form *ngIf="loaded" #f="ngForm" (ngSubmit)="onSubmit(f)" novalidate>
          <div class="row align-items-end">

            <!-- Comentarios -->
            <div class="col-md-12 mb-3">
              <label for="inputComentarios" class="form-label" i18n>Comentarios</label>
              <textarea class="form-control" id="inputComentarios" name="comentarios"
                [(ngModel)]="caso.comentarios" rows="3"></textarea>
            </div>                       

            <!-- Escrutinios/Revisión de Comisión -->
            <div class="col-md-12 mb-3">
              <label for="inputEscrutinios" class="form-label" i18n>Escrutinios/Revisión de Comisión</label>
              <textarea class="form-control" id="inputEscrutinios" name="escrutinios_revision_comision"
                [(ngModel)]="caso.escrutinios_revision_comision" rows="3"></textarea>
            </div>  

            <div class="row">
              <div class="col-md-6 mb-3">
                <label for="inputIncidencias" class="form-label" i18n>Incidencias</label>
                <select2 [data]="incidenciasList" i18n-placeholder="@@incidenciasPlaceholder"
                         placeholder="Selecciona Incidencias" id="inputIncidencias" multiple="true"
                         [(ngModel)]="caso.incidencias" name="incidencias" [value]="incidenciasArray">
                </select2>
              </div>
            
              <div class="col-md-6 mb-3">
                <label for="inputIncidenciasOtras" class="form-label" i18n>Otras Incidencias</label>
                <textarea class="form-control" id="inputIncidenciasOtras" name="incidencias_otras"
                          [(ngModel)]="caso.incidencias_otras" rows="3"></textarea>
              </div>
            </div>

            <!-- Rebeldía -->
            <div class="col-md-4 mb-3">
              <div class="form-check">
                <input class="form-check-input" type="checkbox" id="inputRebeldia" name="rebeldia"
                  [(ngModel)]="caso.rebeldia">
                <label class="form-check-label" for="inputRebeldia" i18n>
                  Rebeldía
                </label>
              </div>
            </div>

            <div class="col-md-12 text-end mb-3">
              <button type="submit" class="btn btn-primary waves-effect waves-light" [disabled]="f.invalid || isCaseClosed()">
                <span i18n>Guardar Cambios</span>
              </button>
            </div>

          </div>
        </form>
      </div>
    </div>
  </div>
</div>
